import { Component, Input } from '@angular/core';
import { ActivatedRoute, RouterLink, RouterLinkActive } from '@angular/router';
import {
  NextPageService,
  NavigationLocation,
  PageLayout,
  NextPage,
} from '@cvx/nextpage';

@Component({
  selector: "left-menu",
  templateUrl: "left-menu.component.html",
  imports: [NextPage, RouterLink, RouterLinkActive],
})
export class LeftMenuComponent {
  @Input() showImportExport: boolean = true;
  @Input() profileMenu: boolean = false;
  NavigationLocation = NavigationLocation;
  PageLayout = PageLayout;

  constructor(private NP: NextPageService, private activatedRoute: ActivatedRoute) { }
}